import { render, staticRenderFns } from "./ContactReportsReviewPage.vue?vue&type=template&id=0da34bd8"
import script from "./ContactReportsReviewPage.vue?vue&type=script&lang=js"
export * from "./ContactReportsReviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports